import { useSelector } from 'react-redux';
import { selectAuth } from '../redux/slices/authSlice';
import { selectAdmins } from '../redux/slices/adminsSlice';

const HOTEL_PERMISSION = 'view_management_company';

const useIsHotelOnlyAdmin = (): boolean => {
  const auth = useSelector(selectAuth);
  const { info } = useSelector(selectAdmins);

  if (auth.info?.type === 'superAdmin') return false;

  const tabs = info?.tabs || [];
  return tabs.length > 0 && tabs.every(tab => tab.code === HOTEL_PERMISSION);
};

export default useIsHotelOnlyAdmin;
